import { motion } from "framer-motion";
import { ADVANTAGES } from "../data";

export const Advantages = () => {
  return (
    <section id="ventajas" className="bg-background py-24 lg:py-32 border-t border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mb-16 max-w-2xl">
          <span className="text-xs uppercase tracking-[0.25em] font-bold text-electric">Por qué elegirnos</span>
          <h2 className="font-heading font-bold text-ink text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-5">
            Ventajas de trabajar con nosotros.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-l border-t border-border">
          {ADVANTAGES.map((a, i) => {
            const Icon = a.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className="group border-r border-b border-border p-8 lg:p-10 hover:bg-muted/60 transition-colors duration-300"
                data-testid={`advantage-${i}`}
              >
                <span className="grid place-items-center w-12 h-12 bg-ink text-white group-hover:bg-electric transition-colors duration-300">
                  <Icon size={22} />
                </span>
                <h3 className="font-heading font-semibold text-ink text-xl mt-6">{a.title}</h3>
                <p className="text-muted-foreground mt-2 text-sm leading-relaxed">{a.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
